import { useLocalStorage } from '@connected/ui/hooks/use-local-storage';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { SupportedLanguage } from '@/config/locales';

export function useLanguageSwitcher() {
    const { i18n } = useTranslation();

    const [locale, setLocale] = useLocalStorage<SupportedLanguage>({
        key: 'language',
        initialValue: i18n.language as SupportedLanguage,
    });

    useEffect(() => {
        i18n.changeLanguage(locale);
    }, [locale, i18n]);

    function changeLanguage(lang: SupportedLanguage) {
        setLocale(lang);
    };

    return [locale, changeLanguage] as const;
}
